import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { MessageService } from '../../services/message.service';
import { ITokens } from './tokens.interface';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private messageService: MessageService,
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (
            request.url.includes('/auth/login') ||
            request.url.includes('/auth/register') ||
            request.url.includes('/auth/refresh')
        ) {
            return next.handle(request);
        }

        const accessToken = this.authService.getAccessToken();

        // создаем копию параметров и тела запроса
        let params = request.params;
        let body = request.body;

        // разрешаем доступ только к списку компаний и текущему пользовалелю
        if (
            this.authService.isAdmin() &&
            !this.authService.companyId() &&
            !request.url.includes('api/companies') &&
            !request.url.includes('api/user/current') &&
            !request.url.includes('api/user/refresh')
        ) {
            return throwError(() => this.messageService.errorMessage('Нужно выбрать компанию'));
        }

        if (this.authService.isAdmin() && this.authService.companyId()) {
            switch (request.method) {
            case 'GET': // добавляем фильтр по компании
                params = params.append('filter.company.id', this.authService.companyId());
                break;
            case 'POST': // добавляем id компании
            case 'PUT':
                if (body && typeof body === 'object') {
                    body = { ...body, companyId: this.authService.companyId() };
                }
                break;
            }
        }

        const cloned = request.clone({
            setHeaders: {
                Authorization: `Bearer ${accessToken}`,
            },
            params: params,
            body: body
        });

        return next.handle(cloned).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    const refreshToken = this.authService.getRefreshToken();
                    if (!refreshToken) {
                        return throwError(() => this.messageService.errorMessage('Сессия истекла. Пожалуйста, войдите снова'));
                    }

                    return this.authService.refreshUserToken({ refreshToken }).pipe(
                        switchMap((res: ITokens) => {
                            this.authService.saveToLocalStorage(res);
                            return next.handle(
                                request.clone({
                                    setHeaders: {
                                        Authorization: `Bearer ${res.accessToken}`,
                                    },
                                }),
                            );
                        }),
                        catchError(() => {
                            this.authService.logout();
                            return throwError(() =>
                                this.messageService.errorMessage('Ошибка обновления токена. Пожалуйста, войдите снова'));
                        }),
                    );
                }

                if (err.status === 403) {
                    this.authService.logout();
                    return throwError(() => this.messageService.errorMessage('Доступ запрещен'));
                }

                return throwError(() => err);
            }),
        );
    }
}
